var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"myVueDropzone",attrs:{"options":_vm.dropzoneOptions,"awss3":_vm.awss3,"id":"dropzone"},on:{"vdropzone-complete":_vm.dzComplete}})
}
var staticRenderFns = []

export { render, staticRenderFns }